const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p>
        Bridge Connectivity Solutions Pvt. Ltd. built the VachanOnline website
        and Vachan Go Mobile app as free tools. These are provided by Bridge
        Connectivity Solutions at no cost and are intended for use as is.
      </p>
      <p>
        This page is used to inform visitors regarding our policies with the
        collection, use, and disclosure of Personal Information if anyone
        decided to use our Service.
      </p>
      <p>
        If you choose to use our Service, then you agree to the collection and
        use of information in relation to this policy. The Personal Information
        that we collect is used for providing and improving the Service. We will
        not use or share your information with anyone except as described in
        this Privacy Policy.
      </p>
      <p>
        The terms used in this Privacy Policy have the same meaning as in our
        Terms and Conditions, which is accessible at VachanOnline.com unless
        otherwise defined in this Privacy Policy.
      </p>
      <h2>Information Collection and Use</h2>
      <p>
        For a better experience, while using our Service, we may require you to
        provide us with certain personally identifiable information. The
        information that we request will be retained by us and used as described
        in this privacy policy.
      </p>
      <div>
        <p>
          The website does use third party services that may collect information
          used to identify you.
        </p>
        <p>
          Links to privacy policy of third-party service providers used by the
          apps
        </p>
        <ul>
          <li>
            <a
              href="https://support.google.com/googleplay/answer/11416267?sjid=12183253204952748197-AP"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play Services
            </a>
          </li>
          <li>
            <a
              href="https://support.google.com/analytics/answer/6004245"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Analytics
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/support/privacy)"
              target="_blank"
              rel="noopener noreferrer"
            >
              Firebase
            </a>
          </li>
        </ul>
      </div>
      <h2>Log Data</h2>
      <p>
        We want to inform you that whenever you use our Service, in case of an
        error in the app we collect data and information (through third party
        products) on your phone called Log Data. This Log Data may include
        information such as your device Internet Protocol (“IP”) address, device
        name, operating system version, the configuration of the app when
        utilizing our Service, the time and date of your use of the Service, and
        other statistics.
      </p>
      <h2>How we use the information we obtain </h2>
      <p>
        We use the information we obtain to understand and analyze how you use
        our website to improve and personalize your experience. It will help us
        to improve our services and maintain it as per our user's needs.
        Communicate with you via email, responding to your inquiries or
        feedback.
      </p>
      <h2>You Have a Choice </h2>
      <p>
        Regarding the personal data we collect from you, including how we get in
        touch with you, we give you options. To change your preferences, send an
        email to{" "}
        <a
          href="mailto:thevachanproject@bridgeconn.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          thevachanproject@bridgeconn.com
        </a>{" "}
        requesting that your information be removed from our mailing lists.
      </p>
      <h2>Data retention</h2>
      <p>
        Personal data will be kept for as long as it is necessary to achieve the
        objectives described in this policy, unless otherwise mandated by law.
      </p>
      <h2>Cookies</h2>
      <p>
        Cookies are files with a small amount of data that are commonly used as
        anonymous unique identifiers. These are sent to your browser from the
        websites that you visit and are stored on your device's internal memory.
      </p>
      <p>
        The website uses some cookies to store some things like the last viewed
        bible version and bible reference etc. to help save your preferences on
        your local device. The website uses third party code and libraries that
        use “cookies” to collect information and improve their services. You
        have the option to either accept or refuse these cookies and know when a
        cookie is being sent to your device. If you choose to refuse our
        cookies, you may not be able to use some portions of this Service.
      </p>
      <h3>Third party cookies </h3>
      <ul>
        <li>
          <a
            href="https://firebase.google.com/support/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Firebase
          </a>
        </li>
      </ul>
      <h3>Disabling Cookies </h3>
      <p>
        You can prevent the setting of cookies by adjusting the settings on your
        browser (see your browser Help for how to do this). Be aware that
        disabling cookies will affect the functionality of this and many other
        websites that you visit. Disabling cookies will usually result in also
        disabling certain functionality and features of this site. Therefore, it
        is recommended that you do not disable cookies.{" "}
      </p>
      <h2>Service Providers</h2>
      <p>
        We may employ third-party companies and individuals due to the following
        reasons:
      </p>
      <ul>
        <li>To facilitate our Service</li>
        <li>To provide the Service on our behalf</li>
        <li>To perform Service-related services</li>
        <li>To assist us in analyzing how our Service is used</li>
      </ul>
      <p>
        We want to inform users of this Service that these third parties have
        access to your Personal Information. The reason is to perform the tasks
        assigned to them on our behalf. However, they are obligated not to
        disclose or use the information for any other purpose.
      </p>
      <h2>Security</h2>
      <p>
        We value your trust in providing us with your Personal Information, thus
        we are striving to use commercially acceptable means of protecting it.
        But remember that no method of transmission over the internet, or method
        of electronic storage is 100% secure and reliable, and we cannot
        guarantee its absolute security.
      </p>
      <h2>Links to Other Sites</h2>
      <p>
        This Service may contain links to other sites. If you click on a
        third-party link, you will be directed to that site. Note that these
        external sites are not operated by us. Therefore, we advise you to
        review the Privacy Policy of these websites. We have no control over and
        assume no responsibility for the content, privacy policies, or practices
        of any third-party sites or services.
      </p>
      <h2>Children’s Privacy</h2>
      <p>
        These Services do not address anyone under the age of 13. We do not
        knowingly collect personally identifiable information from children
        under 13. In the case we discover that a child under 13 has provided us
        with personal information, we immediately delete this from our servers.
        If you are a parent or guardian and you are aware that your child has
        provided us with personal information, please contact us so that we will
        be able to do the necessary actions.
      </p>
      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. Thus, you are
        advised to review this page periodically for any changes. We will notify
        you of any changes by posting the new Privacy Policy on this page.{" "}
      </p>
      <p>This policy is effective as of 2023-12-04.</p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions or suggestions about our Privacy Policy, do
        not hesitate to contact us at {""}
        <a
          href="mailto:thevachanproject@bridgeconn.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          thevachanproject@bridgeconn.com
        </a>
      </p>
    </div>
  );
};
export default PrivacyPolicy;
